"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Story = void 0;
/**
 * A story is a list of clusters with a specific order.
 */
let Story = /** @class */ (() => {
    class Story {
        constructor(clusters, edges) {
            this.clusters = clusters;
            this.edges = edges;
            Story.generator = Story.generator + 1;
            this.uuid = Story.generator;
        }
        getId() {
            return this.uuid;
        }
    }
    Story.generator = 0;
    return Story;
})();
exports.Story = Story;
